export const YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES = {
  WEB_BH_YCX_LIST: 'WEB_BH_YCX_LIST',
  WEB_BH_YCX_LIST_KT: 'WEB_BH_YCX_LIST_KT',
  WEB_BH_YCX_EDIT: 'WEB_BH_YCX_EDIT',
  WEB_BH_YCX_TAO: 'WEB_BH_YCX_TAO',
  WEB_BH_YCX_HUY: 'WEB_BH_YCX_HUY',
  WEB_BH_YCX_DONG_Y: 'WEB_BH_YCX_DONG_Y',
  WEB_BH_YCX_KHONG_DONG_Y: 'WEB_BH_YCX_KHONG_DONG_Y',
  WEB_BH_YCX_GUI_KHACH: 'WEB_BH_YCX_GUI_KHACH',
  WEB_BH_YCX_HOAN_THANH: 'WEB_BH_YCX_HOAN_THANH',
  WEB_BH_YCX_UPLOAD_PDF: 'WEB_BH_YCX_UPLOAD_PDF',
} as const

export const YCX_MUTATE_PERMISSIONS = [
  YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_YCX_EDIT,
  YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_YCX_TAO,
  YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_YCX_HUY,
  YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_YCX_DONG_Y,
  YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_YCX_KHONG_DONG_Y,
  YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_YCX_GUI_KHACH,
  YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_YCX_HOAN_THANH,
  YEU_CAU_XUAT_HOA_DON_PERMISSION_CODES.WEB_BH_YCX_UPLOAD_PDF,
] as const
